import { render, staticRenderFns } from "./CertPopUp.vue?vue&type=template&id=3755a228"
import script from "./CertPopUp.vue?vue&type=script&lang=js"
export * from "./CertPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports